import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()

export class JwtInterceptor implements HttpInterceptor {
  constructor(private router: Router, public activeRoute: ActivatedRoute) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('authToken');
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        }
      });
    }
    else {
      if (this.getUrlWithoutParams != "/login") {
        sessionStorage.setItem("errorMessage", "You do not have the permission to view this page the credentials that you supplied.");
        this.router.navigate(["/error"]);
      }
    }
    return next.handle(request);
  }
  get getUrlWithoutParams(): string {
    return this.router.url.split('?')[0];
  }
}
